import React from "react";
import ContentDetailPage from "@/components/ContentDetailPage";

export default function ArticleDetail() {
  return (
    <ContentDetailPage
      routeBase="/articles"
      backLabel="Back to articles"
      testIdPrefix="article"
    />
  );
}
